import React, { PureComponent } from 'react';
import { Drawer } from './drawer.js';
import { InjectorService } from '@tencent/ioc';
import { withState } from '../../services/store/with-state.js';
import { EnvContext } from '../../controllers/workbench/context.js';
import { BuiltinUiState } from '../../services/store/builtin-state.js';
import { DrawerService } from '../../services/drawer/drawer-service.js';
import styles from './drawer.less.js';
import { PlatformUtil } from '../../utils/platform-utils.js';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, pairwise } from 'rxjs/operators';
import { $logger } from '../../controllers/logger/logger.js';

class RightDrawerComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.domSubject = new Subject();
        this.closingSubDrawers = [];
        this.setDrawerRef = (drawerDom) => {
            this.drawerDom = drawerDom;
            this.domSubject.next(drawerDom);
        };
        this.closeDrawer = () => {
            this.drawerService.closeRightDrawer();
        };
        this.closeSubDrawer = (drawer) => {
            var _a;
            this.drawerService.removeRightSubDrawer(drawer.name);
            (_a = drawer.onClose) === null || _a === void 0 ? void 0 : _a.call(drawer);
            if (!drawer.name)
                return;
            const idx = this.closingSubDrawers.indexOf(drawer.name);
            if (idx >= 0) {
                this.closingSubDrawers.splice(idx, 1);
            }
        };
        this.exitSubDrawer = (name) => {
            if (!name)
                return;
            if (!this.closingSubDrawers.includes(name)) {
                this.closingSubDrawers.push(name);
            }
            this.forceUpdate();
        };
        this.handleClick = (event) => {
            var _a, _b, _c;
            const { onClickOutside } = (_a = this.props.rightDrawerInfo) !== null && _a !== void 0 ? _a : {};
            if (!onClickOutside || !this.drawerDom) {
                return;
            }
            const { clientX: x, clientY: y } = event;
            const { top, left, right, bottom, } = (_c = (_b = this.drawerDom) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) !== null && _c !== void 0 ? _c : {};
            // 如果是外部点击事件，触发传入的 onClickOutside
            if (x < left || right < x || y < top || bottom < y) {
                onClickOutside();
            }
        };
        this.drawerService = InjectorService.get(DrawerService);
        this.handleVisibilityCallbackAfterRendered();
    }
    handleVisibilityCallbackAfterRendered() {
        const domObservable = this.domSubject.pipe(distinctUntilChanged());
        const removeListenerSubject = new Subject();
        this.removeListenerWhenDrawerClose(removeListenerSubject);
        // callback ref 会被调用两次，值可能为空https://github.com/facebook/react/issues/11258
        domObservable.pipe(filter(drawerDom => !!drawerDom), map(() => {
            var _a, _b, _c;
            return ({
                visible: this.props.rightDrawerOpened,
                name: (_a = this.props.rightDrawerInfo) === null || _a === void 0 ? void 0 : _a.name,
                onOpen: (_b = this.props.rightDrawerInfo) === null || _b === void 0 ? void 0 : _b.onOpen,
                onClose: (_c = this.props.rightDrawerInfo) === null || _c === void 0 ? void 0 : _c.onClose,
            });
        }), distinctUntilChanged((prev, curr) => prev.name === curr.name && prev.visible === curr.visible), pairwise()).subscribe(([prev, curr]) => {
            var _a, _b, _c;
            if (curr.visible) {
                if (prev.name !== curr.name) {
                    try {
                        const prevStyle = this.context.store.getValue(BuiltinUiState.RightDrawerStyle);
                        this.drawerService.updateRightDrawerStyle(prevStyle !== null && prevStyle !== void 0 ? prevStyle : {});
                        (_a = prev.onClose) === null || _a === void 0 ? void 0 : _a.call(prev);
                    }
                    catch (e) {
                        $logger.error(`Drawer ${prev.name} onClose has errors:\n${e}`);
                    }
                }
                document.addEventListener('click', this.handleClick, true);
                try {
                    (_b = curr.onOpen) === null || _b === void 0 ? void 0 : _b.call(curr);
                }
                catch (e) {
                    $logger.error(`Drawer ${curr.name} onOpen has errors:\n${e}`);
                }
                return;
            }
            try {
                (_c = curr.onClose) === null || _c === void 0 ? void 0 : _c.call(curr);
            }
            catch (e) {
                $logger.error(`Drawer ${curr.name} onClose has errors:\n${e}`);
            }
            removeListenerSubject.next(true);
        });
    }
    removeListenerWhenDrawerClose(removeListenerSubject) {
        removeListenerSubject.pipe(filter(needToRemove => needToRemove))
            .subscribe(() => {
            document.removeEventListener('click', this.handleClick, true);
            removeListenerSubject.next(false);
        });
    }
    render() {
        var _a, _b;
        const { onBeforeShowRightDrawer, onBeforeCloseRightDrawer, onAfterCloseRightDrawer, onAfterShowRightDrawer, } = this.drawerService;
        return (React.createElement("div", { className: [styles['drawer-container'], styles['drawer-right']].join(' '), style: Object.assign(Object.assign({}, this.props.rightDrawerStyle), { marginTop: this.props[BuiltinUiState.TitlebarDOMVisible] && PlatformUtil.isMobile() ? 44 : '0' }) },
            React.createElement(Drawer, Object.assign({ forwardRef: this.setDrawerRef, service: this.drawerService, align: "right", onDrawerClose: this.closeDrawer, opened: this.props.rightDrawerOpened, onEnter: onBeforeShowRightDrawer, onEntered: onAfterShowRightDrawer, onExit: onBeforeCloseRightDrawer, onExited: onAfterCloseRightDrawer, persistContents: this.props.rightDrawerPersistContent, hiddenContents: this.props.rightDrawerHiddenContent, animationDisabled: this.props.disableDrawerAnimation }, this.props.rightDrawerInfo, { style: Object.assign(Object.assign({}, (_a = this.props.rightDrawerInfo) === null || _a === void 0 ? void 0 : _a.style), { zIndex: 0 }) })),
            ((_b = this.props.rightSubDrawerInfo) !== null && _b !== void 0 ? _b : []).map((drawer, index) => React.createElement(Drawer, Object.assign({ forwardRef: () => { }, key: drawer.name, service: this.drawerService, align: "right", onDrawerClose: () => this.exitSubDrawer(drawer.name), onBack: () => this.exitSubDrawer(drawer.name), opened: !!drawer.name && !this.closingSubDrawers.includes(drawer.name), animationDisabled: this.props.disableDrawerAnimation, onEntered: () => { var _a; return (_a = drawer.onOpen) === null || _a === void 0 ? void 0 : _a.call(drawer); }, onExited: () => this.closeSubDrawer(drawer) }, drawer, { style: Object.assign(Object.assign({}, drawer.style), { zIndex: index + 1 }) })))));
    }
}
RightDrawerComponent.contextType = EnvContext;
const RightDrawer = withState([
    BuiltinUiState.RightDrawerInfo,
    BuiltinUiState.RightDrawerOpened,
    BuiltinUiState.RightDrawerStyle,
    BuiltinUiState.RightDrawerPersistContent,
    BuiltinUiState.RightDrawerHiddenContent,
    BuiltinUiState.TitlebarDOMVisible,
    BuiltinUiState.DisableDrawerAnimation,
    BuiltinUiState.RightSubDrawerInfo,
], false, 30)(RightDrawerComponent);

export { RightDrawer, RightDrawerComponent };
//# sourceMappingURL=right-drawer.js.map
